"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FETCH_REQUEST = 'config/FETCH/REQUEST';
exports.FETCH_SUCCESS = 'config/FETCH/SUCCESS';
exports.FETCH_FAILURE = 'config/FETCH/FAILURE';
//# sourceMappingURL=types.js.map